
var template = "<div class=\"cell medium-4\">\n    <article class=\"analysisCard card\">\n        <h2 class=\"artTitle\"><a :href=\"postData.postUrl\">{{postData.title}}</a></h2>\n        <div class=\"date\">{{postData.create}}</div>\n    </article>\n</div>";


Vue.component('pager', {
    props: ['postData', 'idx'],
    template: template
})

new Vue({
    el: '#vue-journalist',
    data: {
        posts: [],
        page: 1,
        loading: false,
        finish: false,
        id: null
    },
    beforeMount: function () {
        this.id = parseInt(this.$el.attributes['data-match-id'].value);
    },
    mounted: function () {
        epicaAddEventClick('#vue-journalist');
    },
    updated: function () {
        onResize();
        epicaAddEventClick('#vue-journalist');
    },
    methods: {
        getPosts: function () {
            this.page++;
            this.loading = true;
            this.$http.get('/api/JournalistPager/journalist?page=' + this.page + '&id=' + this.id).then(function (response) {
                
                this.posts = this.posts.concat(response.body);
                this.loading = false;
                this.finish = response.body.length == 0;
            }, function (response) {

            });
        }
    }
});